import React, {FunctionComponent} from "react";
import WizardStep from "../WizardStep";
import statusCoin from "../../../images/Progress/progress_muenzen.svg";
import {Grid} from "@material-ui/core";
import GradienBoderButton from "../../../commonComponents/GradientButton";
import {Step} from "../../WizardMap";
import useMaterials from "../../state/hooks/materialHook";
import {Material} from "../../../API";
import {NavigationProps} from "../../slideRouter/navigationHook";

const StepCoinBarMaterial: FunctionComponent<NavigationProps> = ({gotoPrevSlide, gotoNextSlide}) => {

    const {toggleMaterial, materialPresent, materialsToStore, materialIsEmpty} = useMaterials();

    const handleNextClick = (): void => {
        materialsToStore();
        gotoNextSlide(Step.ADD_INFO);
    };

    return (
        <WizardStep
            title={"Um welches Material handelt es sich?"}
            description={"Mehrfachauswahl möglich."}
            icon={statusCoin}
            backButton={true}
            onBackClick={gotoPrevSlide}
            nextButton={true}
            nextButtonDisabled={materialIsEmpty()}
            onNextClick={handleNextClick}
        >
            <Grid container spacing={3} direction={"column"}>
                <Grid item>
                    <GradienBoderButton
                        text={"Gold"}
                        isChecked={materialPresent(Material.GOLD)}
                        onClick={() => toggleMaterial(Material.GOLD)}
                    />
                </Grid>
                <Grid item>
                    <GradienBoderButton
                        text={"Silber"}
                        isChecked={materialPresent(Material.SILVER)}
                        onClick={() => toggleMaterial(Material.SILVER)}
                    />
                </Grid>
                <Grid item>
                    <GradienBoderButton
                        text={"Platin"}
                        isChecked={materialPresent(Material.PLATIN)}
                        onClick={() => toggleMaterial(Material.PLATIN)}
                    />
                </Grid>
                <Grid item>
                    <GradienBoderButton
                        text={"Palladium"}
                        isChecked={materialPresent(Material.PALLADIUM)}
                        onClick={() => toggleMaterial(Material.PALLADIUM)}
                    />
                </Grid>
            </Grid>
        </WizardStep>
    );
};

export default StepCoinBarMaterial;
